/**
 * Modal Block - Deprecated save markup for migration.
 *
 * Preserves the old static save output so existing modal blocks
 * can migrate to the new dynamic render.php approach.
 */
import { useBlockProps, InnerBlocks, RichText } from "@wordpress/block-editor";

const v1 = {
  attributes: {
    buttonText: { type: "string", default: "Click Here" },
    buttonAlign: { type: "string", default: "left" },
    backdropColor: { type: "string", default: "#00000080" },
    enableCloseIcon: { type: "boolean", default: true },
    closeOnBackdropClick: { type: "boolean", default: true },
    closeOnEsc: { type: "boolean", default: true },
    popupStyles: {
      type: "object",
      default: {
        modalWidth: 600,
        modalWidthUnit: "px",
        modalMaxHeight: 90,
        modalMaxHeightUnit: "vh",
        padding: { top: "20px", right: "20px", bottom: "20px", left: "20px" },
        borderWidth: "0px",
        borderColor: "#000000",
        borderStyle: "solid",
        shadow: "",
      },
    },
    closeStyles: {
      type: "object",
      default: {
        closeIconSize: 24,
        closeIconPosition: "top-right",
        closeIconColor: "#ffffff",
      },
    },
  },

  migrate(attributes) {
    return attributes;
  },

  save({ attributes }) {
    const {
      buttonText = "Click Here",
      backdropColor = "#00000080",
      enableCloseIcon = true,
      closeOnBackdropClick = true,
      closeOnEsc = true,
      popupStyles = {},
      closeStyles = {},
    } = attributes;

    const blockProps = useBlockProps.save({
      className: "modal-trigger-button wp-element-button alignfull",
    });

    return (
      <div className="brandy-modal-wrapper">
        <div {...blockProps}>
          <RichText.Content value={buttonText} />
        </div>
        <div
          className="modal-backdrop"
          style={{
            backgroundColor: backdropColor,
            display: "none",
          }}
          data-close-on-backdrop={closeOnBackdropClick.toString()}
          data-close-on-esc={closeOnEsc.toString()}
        >
          <div
            className="modal-wrapper"
            style={{
              width: `${popupStyles.modalWidth || 600}${
                popupStyles.modalWidthUnit || "px"
              }`,
              maxHeight: `${popupStyles.modalMaxHeight || 90}${
                popupStyles.modalMaxHeightUnit || "vh"
              }`,
            }}
          >
            <div
              className="modal-content"
              style={{
                width: "100%",
                maxHeight: `${popupStyles.modalMaxHeight || 90}${
                  popupStyles.modalMaxHeightUnit || "vh"
                }`,
                overflowY: "auto",
                paddingTop: popupStyles.padding?.top || "20px",
                paddingRight: popupStyles.padding?.right || "20px",
                paddingBottom: popupStyles.padding?.bottom || "20px",
                paddingLeft: popupStyles.padding?.left || "20px",
                border: `${popupStyles.borderWidth || "0px"} ${
                  popupStyles.borderStyle || "solid"
                } ${popupStyles.borderColor || "#000000"}`,
                boxShadow: popupStyles.shadow || "",
              }}
            >
              <div
                className="modal-inner-content"
                style={{ maxWidth: "fit-content", margin: "0 auto" }}
              >
                <InnerBlocks.Content />
              </div>
            </div>
            {enableCloseIcon && (
              <button
                className={`modal-close-button ${
                  closeStyles.closeIconPosition || "top-right"
                }`}
                style={{
                  width: `${closeStyles.closeIconSize || 24}px`,
                  height: `${closeStyles.closeIconSize || 24}px`,
                }}
              >
                <svg
                  width="20"
                  height="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill={closeStyles.closeIconColor || "#ffffff"}
                    d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  },
};

export default [v1];
